<template>
  <b-form :readonly="readonly" hide-action-buttons>
    <v-card>
      <v-card-text>
        <div class="mb-4">
          <div
            class="d-flex align-center ga-2 text-uppercase font-weight-bold text-medium-emphasis font-size-11 mb-4">
            <v-icon color="blue-darken-3" size="x-small">mdi-circle</v-icon>
            Основна інформація
          </div>
          <v-divider class="mb-4 border-opacity-10" />

          <v-row>
            <v-col cols="12">
              <b-input
                v-model="contractor.name"
                :error-messages="getErrorMessages(v$.name)"
                hide-details
                label="Повна назва"
                placeholder="Введіть текст"
                @blur="v$.name.$touch()"></b-input>
            </v-col>
            <v-col cols="12" md="6">
              <b-input
                v-model="contractor.shortName"
                :error-messages="getErrorMessages(v$.shortName)"
                hide-details
                label="Коротка назва"
                placeholder="Введіть текст"
                @blur="v$.shortName.$touch()"></b-input>
            </v-col>
            <v-col cols="12" md="6">
              <b-input
                v-model="contractor.code"
                :error-messages="getErrorMessages(v$.code)"
                :mask="'#'.repeat(10)"
                hide-details
                label="ЄДРПОУ/ІПН"
                placeholder="Введіть текст"
                @blur="v$.code.$touch()"></b-input>
            </v-col>
          </v-row>
        </div>

        <div>
          <div
            class="d-flex align-center ga-2 text-uppercase font-weight-bold text-medium-emphasis font-size-11 mb-4">
            <v-icon color="deep-purple" size="x-small">mdi-circle</v-icon>
            Юридична інформація
          </div>
          <v-divider class="mb-4 border-opacity-10" />

          <v-row>
            <v-col cols="12" md="6">
              <b-select
                v-model="contractor.typeId"
                :error-messages="getErrorMessages(v$.typeId)"
                :items="$directory.get('contractorTypes', contractor.type)"
                :loading="$loading.isLoading('contractorTypes')"
                hide-details
                label="Тип"
                placeholder="Оберіть тип"
                @blur="v$.typeId.$touch()"
                @focus="$directory.fill('contractorTypes')"></b-select>
            </v-col>
            <v-col cols="12" md="6">
              <b-input
                :model-value="statusLabel"
                hide-details
                label="Статус"
                readonly></b-input>
            </v-col>
            <v-col cols="12" md="6">
              <b-input
                :model-value="createdAt"
                hide-details
                label="Дата створення"
                readonly></b-input>
            </v-col>
          </v-row>
        </div>

        <div class="d-flex justify-end mt-5">
          <b-action-buttons
            :confirm="updateContractor"
            :disabled="!contractor.$hasChanges || readonly"
            :reject="() => contractor.$reset()">
          </b-action-buttons>
        </div>
      </v-card-text>
    </v-card>
  </b-form>
</template>

<script lang="ts">
import { getErrorMessages } from 'best-modules/utils'
import { BActionButtons, BForm } from 'best-modules/components'
import { useContractorStore } from '@/pages/contractor/single/contractor'

export default {
  name: 'ContractorGeneralTab',
  components: { BForm, BActionButtons },
  methods: { getErrorMessages },
  setup() {
    return useContractorStore()
  },
}
</script>
